module.exports = __webpack_public_path__ + "static/aubrie-67b865e4b9852abf6b8c41c148dabf4b.jpg";